import { Grid, Box, Container } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const ContainerBox = styled.div`
  padding: ${theme.padding.content};
`;

export const PageContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const BackgroundColorContainer = styled.div`
  background: ${theme.palette.background.default};
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const BackgroundGraientContainer = styled.div`
  background: radial-gradient(circle at top left, rgba(79, 155, 123, 0.12), transparent 35%), linear-gradient(to bottom, #f7faf8 0%, #ffffff 55%);
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ContentContainer = styled(Container)`
  padding-top: ${theme.padding.container};
  padding-bottom: ${theme.padding.container};
  min-height: 100%;
`;

export const SectionContainer = styled(Container)`
  padding-bottom: ${theme.padding.container};
`;

export const SectionGrid = styled(Grid)`
  padding-top: ${theme.padding.section};
`;

export const TagGrid = styled(Grid)``;

export const CenteredBox = styled(Box)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const DividerContainer = styled(Box)`
  padding: ${theme.padding.section};
`;

export const MainDiv = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Span = styled.span``;
